import { http } from './http';
import type {
  AcceptInviteRequest,
  ChooseTenantRequest,
  LoginApiResponse,
  LoginRequest,
  RefreshRequest,
  RefreshResponse,
} from './types';

export const authApi = {
  /** Login con solo email e password; il backend restituisce tenantId (o scelta tenant se multipli). */
  login(data: LoginRequest): Promise<LoginApiResponse> {
    return http.post<LoginApiResponse>('/auth/login', data).then((r) => r.data);
  },

  /** Step 2: scelta tenant quando la risposta login è TENANT_SELECTION_REQUIRED. */
  chooseTenant(data: ChooseTenantRequest): Promise<LoginApiResponse> {
    return http
      .post<LoginApiResponse>('/auth/login/choose-tenant', data)
      .then((r) => r.data);
  },

  refresh(data: RefreshRequest): Promise<RefreshResponse> {
    return http.post<RefreshResponse>('/auth/refresh', data).then((r) => r.data);
  },

  logout(data: RefreshRequest): Promise<void> {
    return http.post('/auth/logout', data).then(() => undefined);
  },

  acceptInvite(data: AcceptInviteRequest): Promise<void> {
    return http.post('/users/accept-invite', data).then(() => undefined);
  },

  /** R0.4: Change password (authenticated). Min 10 chars, 3 of: upper, lower, digit, symbol. */
  changePassword(data: { currentPassword: string; newPassword: string }): Promise<void> {
    return http.post('/auth/change-password', data).then(() => undefined);
  },
};
